import { Search } from '@mui/icons-material'
import React, { useState } from 'react'
import ClinicForm from './ClinicForm'
import clinicServices from '../clinicServices';
import { Dialog, DialogContent } from '@mui/material';
import { useAlert } from '../../../context/AlertContext';
import clinicTeamServices from '../clinicTeamServices';

function ClinicSearch({callBack}) {

    const [searchInput,setSearchInput] = useState("");
    const [searchResult,setSearchResult] = useState([])
    const [dialogStatus, setDialogStatus] = useState(false);
    const {AppAlert} = useAlert();

    const doSearch = () =>{
        let payload ={
            clinicTitle :searchInput,
        }
        setSearchResult([]);
        clinicServices.search(payload).then(res=>{
            setSearchResult(res.data);
        }).catch(error=>{
            console.log(error)
        }).finally(()=>{
            setDialogStatus(true);
        })
    }


    const sendJoinRequest = (clinicId) =>{
        let payload ={
            clinicId :clinicId,
        }
        clinicTeamServices.sendJoinRequest(payload).then(res=>{
            AppAlert(res.msg);
        }).catch(error=>{
            console.log(error)
            AppAlert(error.msg,"error");
        }).finally(()=>{
            
        })
    }


    return (
        <>
            <div className="input-group mb-3">
                <input type="text" value={searchInput} className="form-control" placeholder="Search Clinic"
                    onKeyUp={(e)=>{
                        if(e.key === 'Enter'){
                            doSearch();
                        }
                    }}
                    onChange={(e=>{
                        setSearchInput(e.target.value);
                    })}
                />
                <button className="btn btn-outline-secondary" type="button" onClick={doSearch}  ><Search/> </button>
            </div>

            <Dialog
                open={dialogStatus}
                keepMounted
                onClose={()=>setDialogStatus(false)}
                maxWidth="md"
            >
                <DialogContent>
                    <div className='row'>
                        <div className='col-md-12'>
                            <div className="input-group mb-3">
                                <input type="text"  value={searchInput} className="form-control" placeholder="Search Clinic"
                                    onKeyUp={(e)=>{
                                        if(e.key === 'Enter'){
                                            doSearch();
                                        }
                                    }}
                                    onChange={(e=>{
                                        setSearchInput(e.target.value);
                                    })}
                                />
                                <button className="btn btn-outline-secondary" type="button" onClick={doSearch}  ><Search/> </button>
                            </div>
                        </div>
                        <div className='col-md-12'>
                            {searchResult.length > 0 &&
                                <table className='table'>
                                    <tbody>
                                        {searchResult.map(clinic=>
                                            <tr key= {clinic.id}>
                                                <td>{clinic.title}</td>
                                                <td>{clinic.details}</td>
                                                <td><button className='btn btn-outline-primary' onClick={()=>sendJoinRequest(clinic.id)} > Send Join Request</button></td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            }
                            
                        </div>
                    </div>
                </DialogContent>
            </Dialog>
        </>
    )
}

export default ClinicSearch